import { render, staticRenderFns } from "./OpzioniOrdini.vue?vue&type=template&id=072e79c6&scoped=true"
import script from "./OpzioniOrdini.vue?vue&type=script&lang=ts"
export * from "./OpzioniOrdini.vue?vue&type=script&lang=ts"
import style0 from "./OpzioniOrdini.vue?vue&type=style&index=0&id=072e79c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "072e79c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('072e79c6')) {
      api.createRecord('072e79c6', component.options)
    } else {
      api.reload('072e79c6', component.options)
    }
    module.hot.accept("./OpzioniOrdini.vue?vue&type=template&id=072e79c6&scoped=true", function () {
      api.rerender('072e79c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniOrdini.vue"
export default component.exports